__turbopack_context__.v({
  "root": "CatalogMain-module-scss-module__-5vCfq__root",
});
